/**
 * Returns the name to show in the UI:
 *   - display_name if the user has set one,
 *   - otherwise "Member" (we deliberately do NOT fall back to the real account name).
 */
export function getDisplayName(user) {
  if (!user || typeof user !== "object") return "";
  const dn = (user.display_name || "").trim();
  return dn || "Member";
}
